import * as React from 'react';

import { ContentItemProps } from '../TableOfContentType';
import { ContentItemGroupSubLayout } from '../TocContentLayout/ContentItemGroupSubLayout';
import { ContentItem } from './ContentItem';

export const ContentItemGroup = (props: ContentItemProps) => {
  const {
    id,
    sub,
    onClick,
    scrollContainerElm,
    active,
    typographyVariant,
    currentSectionId,
    ...rest
  } = props;
  if (sub && sub.length > 0) {
    return (
      <div className="content-item-group">
        <ContentItem
          id={id}
          onClick={onClick}
          scrollContainerElm={scrollContainerElm}
          active={currentSectionId === id}
          typographyVariant="medium/14"
          {...rest}
        />
        <ContentItemGroupSubLayout className="content-item-group-sub">
          {sub.map((item) => (
            <ContentItem
              typographyVariant="medium/14"
              scrollContainerElm={scrollContainerElm}
              active={item.id === currentSectionId}
              onClick={onClick}
              key={item.id}
              {...item}
            />
          ))}
        </ContentItemGroupSubLayout>
      </div>
    );
  }
  return (
    <ContentItem
      id={id}
      onClick={onClick}
      scrollContainerElm={scrollContainerElm}
      active={id === currentSectionId}
      typographyVariant={typographyVariant}
      {...rest}
    />
  );
};
